import React, { useState } from "react";
import { getImage, getSrc, getSrcSet } from "gatsby-plugin-image";
import { ImageContentCardData } from "types/image-content-card-data";
import { ReactComponent as PlayButton } from "img/icons/play-button.svg";
import VideoModal from 'components/partials/parts/video-modal';
import { VideoData } from 'types/video-data';

type VideoCardProps = {
    card: ImageContentCardData
};

const VideoCard: React.FC<VideoCardProps> = ({ card }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleVideoClick = () => {

        setIsModalOpen(true);

    };

    const imageData = getImage(card.cardImage || null);

    const cardImgSrc = imageData ? getSrc(imageData) : '/img/placeholder/image-content-card.jpg';

    const cardImgSrcSet = imageData ? getSrcSet(imageData) : '/img/placeholder/image-content-card.jpg 1x, /img/placeholder/image-content-card@2x.jpg 2x';

    const videoData: VideoData = {
        id: card.id || '',
        url: card.videoUrl || '',
        title: card.headline || '',
    }


    return (
        <div>
            <div className="video-card">
                <a className="video-image-link video-card__image" onClick={handleVideoClick} href={`javascript:void(0)`}>
                    {imageData && <img src={cardImgSrc} srcSet={cardImgSrcSet} alt={card.cardImageAlt} width={imageData?.width} height={imageData?.height} />}
                    {card.videoThumbnailUrl && <img src={card.videoThumbnailUrl} alt={card.videoThumbnailAlt} width={card.videoThumbnailWidth} height={card.videoThumbnailHeight} />}
                    <div className="play-btn"><PlayButton /></div>
                </a>
                <div className="video-card__content">
                    <h3 className="card-headline h4">{card.headline}</h3>
                </div>
            </div>
            <VideoModal videoData={videoData} isOpen={isModalOpen} closeModal={() => { setIsModalOpen(false) }} />
        </div>
    );
};

export default VideoCard;